import React from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Divider,
  Button,
  MenuItem,
  Grid,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import OptionInput from "./OptionInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const QuestionBlock = ({
  question,
  index,
  onChange,
  onRemove,
  onOptionChange,
  onAddOption,
  onRemoveOption,
  totalQuestions,
}) => {
  const isMCQ = question.type === "mcq";
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }], // ✅ Text and background color
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"], // remove formatting
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];
  return (
    <Box p={2} border={1} borderRadius={2} borderColor="grey.300" mb={3}>
      {/* Header with Question label and delete icon */}
      <Grid container alignItems="center" justifyContent="space-between" mb={1}>
        <Grid item>
          <Typography variant="h6">Question {index + 1}</Typography>
        </Grid>
        <Grid item>
          <IconButton onClick={() => onRemove(index)} color="error">
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>

      {/* Question Text */}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <label
            style={{
              fontSize: "14px",
              fontWeight: 500,
              marginBottom: "4px",
              display: "block",
            }}
          >
            Question Text
          </label>
          <ReactQuill
            theme="snow"
            value={question.question_text || ""}
            onChange={(value) => onChange(index, "question_text", value)}
            modules={quillModules}
            formats={quillFormats}
            style={{
              backgroundColor: "white",
              minHeight: "120px",
              maxHeight: "300px",
              overflowY: "auto",
            }}
          />
          <style>
            {`
              .ql-toolbar {
                position: sticky;
                top: 0;
                z-index: 10;
                background: white;
              }
            `}
          </style>

          {/* {validationErrors?.[`question_text_${index}`] && (
            <p
              style={{
                color: "red",
                fontSize: "12px",
                marginTop: "4px",
              }}
            >
              {validationErrors[`question_text_${index}`]}
            </p>
          )} */}
        </Grid>
      </Grid>

      {/* Marks, Negative Marks, Type */}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} md={2}>
          <TextField
            label="Marks"
            type="number"
            size="small"
            sx={{ backgroundColor: "white" }}
            fullWidth
            value={question.marks}
            onChange={(e) => onChange(index, "marks", e.target.value === "" ? "" : Number(e.target.value))
          }
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            label="Negative Marks"
            type="number"
            size="small"
            sx={{ backgroundColor: "white" }}
            fullWidth
            value={question.negative_marks}
            onChange={(e) => onChange(index, "negative_marks", e.target.value === "" ? "" : Number(e.target.value))          }
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            select
            label="Sort Order"
            fullWidth
            size="small"
            sx={{ backgroundColor: "white" }}
            value={question.sort_order || index + 1}
            onChange={(e) =>
              onChange(index, "sort_order", Number(e.target.value))
            }
          >
            {[...Array(totalQuestions + 5)].map((_, i) => (
              <MenuItem key={i} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            select
            label="Type"
            fullWidth
            size="small"
            sx={{ backgroundColor: "white" }}
            value={question.type}
            onChange={(e) => onChange(index, "type", e.target.value)}
          >
            <MenuItem value="mcq">Multiple Choice</MenuItem>
            <MenuItem value="text">Text Answer</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      {/* Conditional Rendering Based on Type */}
      {isMCQ ? (
        <>
          <Divider sx={{ mb: 2 }} />
          <Typography fontWeight={600} mb={1}>
            Options:
          </Typography>

          {question.options.map((option, optIndex) => (
            <OptionInput
              key={optIndex}
              index={optIndex}
              option={option}
              onChange={(i, field, value) =>
                onOptionChange(index, i, field, value)
              }
              onRemove={() => onRemoveOption(index, optIndex)}
              totalOptions={totalQuestions}
            />
          ))}

          <Button
            startIcon={<AddCircleIcon />}
            onClick={() => onAddOption(index)}
            sx={{ mt: 1 }}
          >
            Add Option
          </Button>
        </>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <label
              style={{
                fontSize: "14px",
                fontWeight: 500,
                marginBottom: "4px",
                display: "block",
              }}
            >
              Correct Answer (Text)
            </label>
            <ReactQuill
              theme="snow"
              value={question.answer_text || ""}
              onChange={(value) => onChange(index, "answer_text", value)}
              modules={quillModules}
              formats={quillFormats}
              style={{
                backgroundColor: "white",
                minHeight: "120px",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            />
            <style>
              {`
                .ql-toolbar {
                  position: sticky;
                  top: 0;
                  z-index: 10;
                  background: white;
                }
             `}
            </style>

            {/* {validationErrors?.[`answer_text_${index}`] && (
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "4px",
                }}
              >
                {validationErrors[`answer_text_${index}`]}
              </p>
            )} */}
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default QuestionBlock;
